export default defineNuxtPlugin(() => {
  const { proxy } = useScriptGoogleTagManager()

  useScriptEventPage(({ title, path }) => {
    proxy.dataLayer.push({
      event: 'pageview',
      pageTitle: title,
      pagePath: path,
    })
  })
})
